<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox mt20">
                <h5>{{mainmenuitem.title}}</h5>
                <p>{{mainmenuitem.description}}</p>
            </div>
            <ul class="titlemenu mt50">
                 <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                    <a href="javascript:void(0)" @click="gotoinfo(menu)">{{menu.title}}</a>
                </li>
            </ul>
            <jobmenu :menuarray="childmenus" @gotoinfo="gotoinfo" :pid="pid"></jobmenu>
        </div>
        <div class="p_body container">
            <!-- <p class="p_joinus_head">
                {{introstring}}
            </p> -->
            <ul class="p_joinus_body">
                <li v-for="(item) in tableData" :key="item.id">
                    <div class="p_ju_front">{{formatdata(item.createdTimeStr)}}</div>
                    <div class="p_ju_mid" @click="gotodetail(item.id)">
                        <h5>{{item.title}}</h5>
                        <p>{{item.resourse}}</p>
                        <div class="meta">
                            <i class="icon_calendar"></i> {{  (item.description && item.description.split('/').length>0) ? item.description.split('/')[0] : ""}}
                            <span>|</span> 
                            <i class="icon icofont-user-alt-3"></i> {{ (item.description && item.description.split('/').length>0) ?item.description.split('/')[1] : ""}}
                            <span>|</span> 
                            <i class="icon_folder-alt"></i> {{ (item.description && item.description.split('/').length>0) ? item.description.split('/')[2] : ""}}
                    
                        </div>
                    </div>
                    <div class="p_ju_end">
                        <a href="javascript:void(0)" @click="gotodetail(item.id)">MORE ></a>
                    </div>
                </li>
           
            </ul>
            <Pager
            v-if="!dataChanged" 
            ref="pager"
            :pageSize="pageSize" 
            :curPage="curPage" 
            :total="total"  
            @setPage="gotoPage"
            @setRowNum="changeRowNum" />
        </div>
    </div>
</template>


<script>


import util from '@/tools/js/util';
import Pager from '@/components/Pager'
import configration from '@/tools/js/enumconfig'
import jobmenu from '../../components/jobmenu'

export default {
    data(){
        return {
            totleCount:0,
            itemData:{},
            tableData:[],
            parameters:{
                CurrentPage:1,
                PageSize:10,
                filter:{
                    parentId:'',
                    Type:0
                }
            },
            id:'',
            showtitle:'加入我们',
            imgbaseurl : this.$baseURL.fileurl,
            
            pidemployeecare:configration.config.enum.pidemployeecare,
            pidemployment:configration.config.enum.pidemployment,
            pidlinian:configration.config.enum.pidlinian,

            //分页
            curPage:1,//当前页
            total:0,//总共页数
            pageSize:20,//每页记录数 
            dataChanged:false,

            introstring:'',

            mainmenuitem:{},            //主显示分类
            childmenutree:[],   //  treemenu
            childmenus:[],
            fid:'',
            pid:''
        }
    },
     components:{
       "Pager":Pager,
       jobmenu
    },
     methods:{
        refresh(){//用于刷新组件，需手动调用
            this.dataChanged = true
            this.$nextTick(() => {
                this.getList();
                this.dataChanged = false
            })
        },

        initmenu(){
            let vm = this;

            if(vm.childmenutree == undefined || vm.childmenutree.length == 0) 
            { 
                vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
            }

            vm.childmenus = [];
            if(vm.fid.length>0){
                //获取子菜单
                for(let i=0;i< vm.childmenutree.length;i++ ){
                    if(vm.childmenutree[i].id == vm.fid)
                    {
                        vm.mainmenuitem = vm.childmenutree[i];
                        vm.childmenus = vm.childmenutree[i].childs;
                        break;
                    }
                }
            }
        },

        gotoPage(page){
            this.curPage = page;
            this.refresh();
        },
        changeRowNum(pageSize){
            this.pageSize = pageSize;
            this.refresh();
        },
        formatdata:function(e){
            //return util.formatDate.format(e,'yyyy-MM')
            return e.substr(0,7);
            //return e.toString();
        },
        dateFtt:function(fmt,date) 
        { //author: meizz 
        var o = { 
        "M+" : date.getMonth()+1,     //月份 
        "d+" : date.getDate(),     //日 
        "h+" : date.getHours(),     //小时 
        "m+" : date.getMinutes(),     //分 
        "s+" : date.getSeconds(),     //秒 
        "q+" : Math.floor((date.getMonth()+3)/3), //季度 
        "S" : date.getMilliseconds()    //毫秒 
        }; 
        if(/(y+)/.test(fmt)) 
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
        for(var k in o) 
        if(new RegExp("("+ k +")").test(fmt)) 
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length))); 
        return fmt; 
        },
        getparentData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/dictionary/DictionaryEntry/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                    vm.introstring = response.data.data.description
                }
            });
        },

        getList:function(){
            let vm = this;
            vm.parameters.PageSize = vm.pageSize;
            vm.parameters.CurrentPage = vm.curPage;
            vm.$httpi.post('/api/v1/articles/doc/GetList', vm.parameters)
            .then(function (response) {
                if(response.data.success){
                    vm.tableData = response.data.data.list;
                    vm.total = response.data.data.total;
                    //vm.curPage = response.data.data.total;
                    vm.tableData.forEach(el=>{
                        el.createdTime = util.formatDate.format(el.createdTime,'yyyy-MM-dd')
                    });

                }
            });
            
        },
        gotodetail(id){
            const vm = this;
            vm.$router.push({path:'/job/find/detail',query:{id:id,pid:vm.pid,fid:vm.fid}});
        },

        gotoinfo(item){
            const vm = this;
   
            switch(item.code){
                case 'doc-joinus-social':
                case 'doc-joinus-shool':
                    vm.$router.push({path:'/job/find/list',query:{pid:item.id,fid:item.parentId}});
                    break;
                default:
                    vm.$router.push({path:'/job/info',query:{pid:item.id,fid:item.parentId}});
                                //vm.getData(item.id);
                    break;
            }
        },
        initpage(){
            let vm = this;
            //绑定
            // if(vm.$route.query.id!=undefined && vm.$route.query.id.length>0)
            // {
            //     vm.id = vm.$route.query.id;
            //     vm.getData(vm.$route.query.id);
            // }
            if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0)
            {
                vm.fid = vm.$route.query.fid;
            }
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.parameters.filter.parentId = vm.$route.query.pid;
                vm.pid = vm.$route.query.pid;
                vm.getList();
                vm.getparentData(vm.$route.query.pid);
            }
            vm.initmenu();
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();
    },
    watch: {
        '$route' (to, from) { //监听路由是否变化
            if(to.query.pid != from.query.pid){
                this.parameters.filter.parentId = to.query.pid;
                this.pid = to.query.pid;
                this.getList();//重新加载数据
                this.getparentData(to.query.pid);
            }
        }
    }
}
</script>